import { Accordion } from '@base-ui/react/accordion';
import styled from 'styled-components';
export const StyledRoot = styled(Accordion.Root) `
  width: 100%;
`;
